export enum RowSelection {
    FullDetail = 'fullDetail',
    SummaryRows = 'summaryRows',
    SummaryColumns = 'summaryColumns',
}
